import React, { useEffect } from 'react';
import { X } from 'lucide-react';

/**
 * Full-screen image modal — shared by GenericFeatureList and GenericFeatureForm.
 * Props: imageUrl (string|null), onClose (function)
 */
const ImageModal = ({ imageUrl, onClose }) => {
  useEffect(() => {
    if (!imageUrl) return;
    const handler = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', handler);
    return () => document.removeEventListener('keydown', handler);
  }, [imageUrl, onClose]);

  if (!imageUrl) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 p-4"
      onClick={onClose}
      role="dialog"
      aria-label="Xem ảnh phóng to"
    >
      <div className="relative max-w-3xl w-full" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="absolute -top-10 right-0 text-white hover:text-gray-300 transition-colors" aria-label="Đóng">
          <X size={28} />
        </button>
        <img src={imageUrl} alt="Xem ảnh" className="w-full h-auto max-h-[80vh] object-contain rounded-lg"
             onError={(e) => { e.target.alt = 'Không tải được ảnh'; }} />
      </div>
    </div>
  );
};

export default ImageModal;
